import { format, parse, isValid } from "date-fns";

export const fmtMonth = (yyyymm) => {
  if (!yyyymm) return "";
  const parsed = parse(yyyymm, "yyyy-MM", new Date());
  if (!isValid(parsed)) return yyyymm;
  return format(parsed, "MMM yyyy");
};

export const dateRange = (start, end, current) => {
  const s = fmtMonth(start);
  const e = current ? "Present" : fmtMonth(end);
  if (!s && !e) return "";
  if (!s) return e;
  if (!e) return s;
  return `${s} — ${e}`;
};

export const joinNonEmpty = (arr, sep = " · ") =>
  arr.filter(Boolean).join(sep);
